export const tableConfig = {
    configuration: true,
    table: {
        leftWidth: 100,
        height: 250,
        selection: true,
        columns: [
            {
                label: '分公司',
                prop: 'companyName',
                sort: true
            },
            {
                label: '分公司编码',
                prop: 'companyCode',
                sort: true
            },
            {
                label: '供应商编码',
                prop: 'carrierCode',
                sort: true
            },
            {
                label: '供应商名称',
                prop: 'carrierName',
                sort: true
            }
        ],
        action: {
            list: []
        }
    },
    leftOperation: false,
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    }
};

export const importConfig = {
    multiple: false,
    accept: '.xlsx,.xls,.pdf,.jpg,.png',
    showFileList: false,
    manualUpload: true
};

export const verifyConfig = {
    switch: true, // 是否开启校验
    fileSize: '',
    whiteList: ['xlsx', 'xls', 'pdf', 'jpg', 'png'] // 校验文件格式
};
